import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';

import HeaderImage from 'images/forum/header-black-text-red.svg';
import GearIcon from 'images/gear.svg';

import { useAppContext } from '../../../contexts/AppContext';
import { edit_user_email_settings_path, forum_path, new_forum_post_path } from '../../../routes';
import { User } from '../../../utils/backend-api/currentUser';
import { Tooltip } from '../../BaseUI';
import { FlexLink } from '../../shared';
import ForumGhostButton from '../ForumGhostButton';
import NewForumPostButton from '../NewForumPostButton';
import styles from './styles.module.scss';

const cookies = new Cookies();

export default function ForumHeader({ currentUser }: { currentUser: User }) {
  const { isWebview } = useAppContext();
  const [showTooltip, setShowTooltip] = useState(true);
  const location = useLocation();

  // For Directory/Forum Launch - TODO: remove after launch
  useEffect(() => {
    const hasVisitedForumPage = cookies.get('hasVisitedForumPage');
    cookies.set(
      'hasVisitedForumPage',
      (hasVisitedForumPage ? parseInt(hasVisitedForumPage) || 0 : 0) + 1
    );
  }, []);

  return (
    <div className={styles.header}>
      <div className="container container-padded">
        <div className={styles.headerContent}>
          <div className={styles.headerDescription}>
            <FlexLink href={forum_path()}>
              <img src={HeaderImage} alt="The Information Forum" className={styles.headerTitle} />
            </FlexLink>
            <div className={styles.headerSubtitle}>
              Follow and join in on serious discussions about tech, finance and media with others
              who share your same passion for the topics. No noise.
            </div>
          </div>
          {currentUser && currentUser?.permitted_to_comment && (
            <div className={styles.headerActions}>
              {location.pathname !== new_forum_post_path() && (
                <div className={styles.writePostBtnWrapper}>
                  <NewForumPostButton />
                  {/* // For Directory/Forum Launch - TODO: remove after launch */}
                  {!isWebview &&
                    (!cookies.get('hasVisitedForumPage') ||
                      cookies.get('hasVisitedForumPage') == 1) && (
                      <Tooltip
                        actionMessage="Got It!"
                        onClose={() => setShowTooltip(false)}
                        isLaunchTooltip
                        message="Write a new post and start a discussion"
                        showTooltip={showTooltip}
                      />
                    )}
                </div>
              )}
              {!isWebview && (
                <ForumGhostButton
                  linkUrl={edit_user_email_settings_path()}
                  svgIcon={GearIcon}
                  text="EMAIL SETTINGS"
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
